import { Card, Button, InputGroup } from 'react-bootstrap'
import useCreatePartnerToken from 'hooks/use-create-partner-token'
import useGetPartnerToken from 'hooks/use-get-partner-token'
import toast from 'react-hot-toast'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

const tokenLinkStyle = `
  .token-link:hover {
    opacity: 0.8;
    transition: opacity 0.2s;
  }
`

export const OrganizationPartnerTokenCard = ({ orgId }: { orgId: string }) => {
  const history = useHistory()
  const {
    data: tokenData,
    refetch,
    isLoading: isInitialLoading,
  } = useGetPartnerToken(orgId)
  const createPartnerToken = useCreatePartnerToken()

  const partnerIntegrations = tokenData?.data || []

  const handleCreateToken = () => {
    createPartnerToken.mutate(
      { orgId },
      {
        onSuccess: () => {
          toast.success('Partner integration created successfully')
          refetch()
        },
        onError: () => {
          toast.error('Failed to create partner integration')
        },
      }
    )
  }

  const handleViewIntegrationClick = (integrationId: number) => {
    history.push(
      `/organizations/${orgId}/partner-integrations/${integrationId}`
    )
  }

  return (
    <>
      <style>{tokenLinkStyle}</style>
      <Card className="mt-4">
        <Card.Header>
          <h4 className="mb-0">Partner Integrations</h4>
        </Card.Header>
        <Card.Body>
          {isInitialLoading ? (
            <div className="text-center">Loading...</div>
          ) : partnerIntegrations.length > 0 ? (
            <div className="d-flex flex-column gap-2">
              {partnerIntegrations.map((integration) => (
                <div
                  key={integration.id}
                  onClick={() => handleViewIntegrationClick(integration.id)}
                  style={{
                    backgroundColor: '#303030',
                    color: '#fff',
                    padding: '10px 12px',
                    fontSize: '13px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    border: '1px solid #404040',
                  }}
                  className="token-link d-flex align-items-center justify-content-between"
                >
                  <div className="d-flex align-items-center gap-3">
                    <span>{integration.name}</span>
                    <small style={{ opacity: 0.7 }}>ID: {integration.id}</small>
                  </div>
                  <code style={{ fontFamily: 'monospace', fontSize: '14px' }}>
                    {integration.token}
                  </code>
                </div>
              ))}
              <div className="mt-2">
                <Button
                  variant="success"
                  onClick={handleCreateToken}
                  disabled={createPartnerToken.isLoading}
                >
                  {createPartnerToken.isLoading
                    ? 'Creating...'
                    : 'Create Partner API'}
                </Button>
              </div>
            </div>
          ) : (
            <div className="text-center">
              <p className="text-muted mb-3">No partner integrations found</p>
              <Button
                variant="success"
                onClick={handleCreateToken}
                disabled={createPartnerToken.isLoading}
              >
                {createPartnerToken.isLoading
                  ? 'Creating...'
                  : 'Create Partner API'}
              </Button>
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  )
}
